import { render, staticRenderFns } from "./ReadAll.vue?vue&type=template&id=977f3ff4&scoped=true&"
import script from "./ReadAll.vue?vue&type=script&lang=js&"
export * from "./ReadAll.vue?vue&type=script&lang=js&"
import style0 from "./ReadAll.vue?vue&type=style&index=0&id=977f3ff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977f3ff4",
  null
  
)

export default component.exports